import type { enCampaigns } from "./en.campaigns";

/** Russian for the campaign list (see `en.campaigns.ts`). Words from the boards Camp*. */
export const ruCampaigns: Record<keyof typeof enCampaigns, string> = {
  "camps.title": "Кампании",
  "camps.fold.label": "Как показать кампании",
  "camps.fold.list": "Списком",
  "camps.fold.groups": "По группам",
  "camps.fold.offers": "По офферам",
  "camps.fold.buyers": "По баерам",
  "camps.columns": "Колонки: {set}",
  "camps.csv": "CSV",
  "camps.rowNote": "клик по строке — карточка",
  "camps.groupsNote": "{count} шапок · цифры шапки — сервера",
  "camps.loadingNote": "загружаем {period}…",
  "camps.search": "Название, sub, id",
  "camps.retry": "Повторить",
  "camps.cancel": "Отмена",
  "camps.quick.active": "Активные",
  "camps.quick.myActive": "Мои активные",
  "camps.quick.losing": "Сливают",
  "camps.quick.noclicks": "Нет кликов",
  "camps.quick.hold50": "Холд > 50%",
  "camps.quick.archive": "Архив",
  "camps.col.name": "Кампания",
  "camps.col.status": "Статус",
  "camps.col.outcome": "Исход лидов",
  "camps.band.traffic": "Трафик",
  "camps.band.conversions": "Конверсии",
  "camps.band.money": "Деньги",
  "camps.band.custom": "Свои",
  "camps.delta.hint": "Изменение к периоду сравнения",
  "camps.total": "Итого, {count} {campaigns}",
  "camps.total.filtered": "Итого по фильтру, {count}",
  "camps.badge.losing": "Сливает",
  "camps.badge.noClicks": "Нет кликов",
  "camps.badge.manualCost": "Расход вручную",
  "camps.badge.imported": "Импорт · {label}",
  "camps.import.manage": "Управлять",
  "camps.import.locked": "Кампания управляется в {label} — изменения там",
  "camps.group.count": "{count}",
  "camps.group.noGroup": "Без группы",
  "camps.group.noOffer": "Не дошли до оффера",
  "camps.group.noOwner": "Без баера",
  "camps.group.buyer": "Баер {id}",
  "camps.group.spendWithoutClicks": "Расход без кликов",
  "camps.kpi.bots": "боты {pct} отсеяны",
  "camps.kpi.cr": "CR {cr}",
  "camps.kpi.approve": "апрув {pct} из решённых",
  "camps.kpi.hold": "В холде",
  "camps.kpi.inFlight": "≈ {sum} в пути",
  "camps.kpi.epc": "EPC {epc}",
  "camps.kpi.cpa": "CPA {cpa}",
  "camps.kpi.was": "было {value}",
  "camps.facet.owner": "Баер",
  "camps.facet.source": "Источник",
  "camps.facet.group": "Группа",
  "camps.facet.geo": "Гео",
  "camps.facet.offer": "Оффер",
  "camps.facet.status": "Статус",
  "camps.facet.metrics": "Метрики",
  "camps.filter.any": "Все",
  "camps.status.ACTIVE": "Активна",
  "camps.status.PAUSED": "Пауза",
  "camps.status.DRAFT": "Черновик",
  "camps.filter.add": "Фильтр",
  "camps.filter.facets": "Фильтры",
  "camps.filter.active": "Применённые фильтры",
  "camps.filter.remove": "Убрать фильтр: {name}",
  "camps.filter.edit": "Изменить фильтр: {name}",
  "camps.filter.search": "Найти: {name}",
  "camps.filter.apply": "Применить",
  "camps.filter.reset": "Сбросить",
  "camps.filter.nothing": "Ничего не нашлось",
  "camps.filter.loading": "Загружаем варианты",
  "camps.filter.back": "Назад",
  "camps.metrics.title": "По метрикам",
  "camps.metrics.all": "все условия сразу",
  "camps.metrics.addRow": "Условие",
  "camps.metrics.field": "Метрика",
  "camps.metrics.operator": "Сравнение",
  "camps.metrics.value": "Значение",
  "camps.metrics.remove": "Убрать условие",
  "camps.metrics.none": "Условий пока нет",
  "camps.metrics.format": "Введите число",
  "camps.metrics.counting": "Считаем…",
  "camps.metrics.found": "Найдено {count} {campaigns}",
  "camps.metrics.saveAsView": "Сохранить как вид",
  "camps.op.lt": "меньше",
  "camps.op.lte": "не больше",
  "camps.op.gt": "больше",
  "camps.op.gte": "не меньше",
  "camps.op.eq": "равно",
  "camps.op.neq": "не равно",
  "camps.view.add": "Сохранить вид",
  "camps.view.toolbar": "Виды",
  "camps.view.createAria": "Сохранить текущие фильтры как вид",
  "camps.view.chip": "Вид «{name}»",
  "camps.view.chipShared": "Вид «{name}», виден всем",
  "camps.view.delete": "Удалить вид «{name}»",
  "camps.view.more": "Ещё {n}",
  "camps.view.moreAria": "Ещё видов: {n}",
  "camps.view.title": "Сохранить вид",
  "camps.view.description": "Вид запоминает фильтры, группировку, колонки и сортировку. Период не запоминается — он общий для всех страниц.",
  "camps.view.name": "Название",
  "camps.view.namePlaceholder": "Сливают с лидами",
  "camps.view.shared": "Видят все в пространстве",
  "camps.view.sharedHint": "иначе — только вы",
  "camps.view.keeps.filters": "Фильтры",
  "camps.view.keeps.fold": "Группировка",
  "camps.view.keeps.columns": "Колонки",
  "camps.view.keeps.sort": "Сортировка",
  "camps.view.noFilters": "нет",
  "camps.view.save": "Сохранить вид",
  "camps.view.saved": "Вид «{name}» сохранён",
  "camps.view.deleted": "Вид «{name}» удалён",
  "camps.sort.asc": "по возрастанию",
  "camps.sort.desc": "по убыванию",
  "camps.set.money": "Деньги",
  "camps.set.moneyWide": "Деньги + качество",
  "camps.set.funnel": "Воронка",
  "camps.set.quality": "Качество трафика",
  "camps.set.compare": "Сравнение",
  "camps.set.mine": "Мои",
  "camps.cols.title": "Колонки",
  "camps.cols.description": "Какие цифры показывает таблица. Набор выбирается в один клик; галочка делает набор вашим.",
  "camps.cols.sets": "Набор",
  "camps.cols.save": "Сохранить набор",
  "camps.cols.reset": "Сбросить",
  "camps.cols.empty": "Колонок нет",
  "camps.cols.close": "Закрыть",
  "camps.cols.goals": "Цели",
  "camps.cols.saveTitle": "Сохранить набор колонок",
  "camps.cols.saveDescription": "Набор виден в списке кампаний и в отчётах.",
  "camps.cols.saved": "Набор «{name}» сохранён",
  "camps.cols.order": "Порядок · {count}",
  "camps.cols.move": "Переставить «{name}» — перетащите или Alt+↑/↓",
  "camps.cols.moved": "«{name}»: место {position} из {total}",
  "camps.csv.level": "Уровень",
  "camps.csv.group": "Группа",
  "camps.csv.campaign": "Кампания",
  "camps.csv.total": "Итого",
  "camps.csv.empty": "Выгружать нечего",
  "camps.csv.failed": "Не удалось выгрузить CSV",
  "camps.error.title": "Не удалось обновить цифры.",
  "camps.error.stale": "Сервер отчётов не ответил. Ниже — данные на {time}.",
  "camps.empty.first.title": "Кампаний пока нет",
  "camps.empty.first.body": "Кампания связывает рекламу с оффером: даёт ссылку для объявления, считает клики и лиды и показывает, сколько вы заработали.",
  "camps.empty.first.cta": "Создать кампанию",
  "camps.empty.has": "{what} — {name}",
  "camps.empty.none": "{what} — ещё нет",
  "camps.empty.partner": "Партнёрка",
  "camps.empty.source": "Источник",
  "camps.empty.offer": "Оффер",
  "camps.empty.lander": "Ленд",
  "camps.empty.domain": "Домен",
  "camps.empty.quiet.eyebrow": "Есть кампании, нет трафика за период",
  "camps.empty.quiet.title": "За {period} кликов не было",
  "camps.empty.quiet.body": "{count} {campaigns} есть, но ни одна не получала трафик в эти дни.",
  "camps.empty.quiet.last": "Последний клик был {age} назад — {day} в {time}.",
  "camps.empty.quiet.longer": "Показать 30 дней",
  "camps.empty.quiet.list": "Показать все кампании без цифр",
  "camps.empty.filtered.title": "Ни одна кампания не подходит",
  "camps.empty.filtered.body": "За этот период под фильтры и условия ничего не попало.",
  "camps.empty.filtered.reset": "Сбросить фильтры",
};
